<template>
  <div class="fluid-container p-1">
    <b-col class="border rounded shadow col-md-4 m-auto p-2 p-md-4">
    <b-form @submit="onSubmit">
      <b-form-group class="p-0" label="Username:" label-for="input-1">
        <b-form-input 
          id="input-1"
          v-model="form.username"
          required
          placeholder="Enter username"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="Password:" label-for="input-2">
        <b-form-input
          id="input-2"
          v-model="form.password"
          type="password"
          required
          placeholder="Enter Password"
        ></b-form-input>
      </b-form-group>
      
      <b-button type="submit" variant="primary">Login</b-button>
      <b-alert class="m-2"
      :show="dismissCountDown"
      dismissible
      fade
      :variant="variant"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
    >
      {{responseMSG}}
    </b-alert>
    </b-form>
    </b-col>

  </div>
</template>

<script>
/* eslint-disable */ 
  export default {
    name: "Login",
    data() {
      return {
        form: {
          username: '',
          password: ''  
        },
        dismissSecs: 2,
        dismissCountDown: 0,
        variant: 'success',
        responseMSG: ''
      }
    },
    props: {
      authenticated: {}
    }, 
    methods: {
      onSubmit(evt) {
        evt.preventDefault()
        let currentObj = this;
        let params = new URLSearchParams();
        params.append('username', this.form.username);
        params.append('password', this.form.password );
        this.axios.post('https://www.aperturefilms.com.au/customer-portal/login.php', params)
                .then(function (response) {
                    currentObj.$emit('authenticated', response.data)
                    if(!response.data.Authenticated) {
                      currentObj.showAlert('danger', 'Username or Password incorrect')
                    }
                })
                .catch(function (error) {
                    console.log(error);  
                });
      },
      countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      },
      showAlert(type, msg) {
        this.responseMSG = msg
        this.variant = type
        this.dismissCountDown = this.dismissSecs
      }
    }
  }
</script>
<style scoped>
.fluid-container {
     margin-top: 110px;

}
</style>